import { EProjectPermission } from "@frontend-shared/types";
import { canBrowseAssistantMarketplace } from "@frontend-shared/utils";

import { useAuth } from "@/hooks/use-auth";
import { usePermissionCheck } from "@/hooks/use-permission";

const MARKETPLACE_BROWSE_PERMISSION_CHECKS: EProjectPermission[] = [
  EProjectPermission.MARKETPLACE_ASSISTANT_READ,
  EProjectPermission.MARKETPLACE_ASSISTANT_WRITE,
];

// NOTE: NSAI-5274 — whether the assistant marketplace can be browsed here, read
// by both the browse query and the Marketplace tab gate: write implies read, and
// a personal project has no marketplace (see `canBrowseAssistantMarketplace` in
// frontend-shared, shared with the mobile hook of the same name).
export const useCanBrowseAssistantMarketplace = (): boolean => {
  const { isPersonalProject } = useAuth();
  const [
    hasMarketplaceAssistantReadPermission,
    hasMarketplaceAssistantWritePermission,
  ] = usePermissionCheck(MARKETPLACE_BROWSE_PERMISSION_CHECKS);

  return canBrowseAssistantMarketplace({
    isPersonalProject,
    hasMarketplaceAssistantReadPermission:
      hasMarketplaceAssistantReadPermission === true,
    hasMarketplaceAssistantWritePermission:
      hasMarketplaceAssistantWritePermission === true,
  });
};
